import { render } from "./ViewOrganizationGeneralInformation.vue?vue&type=template&id=e19120c2&scoped=true"
import script from "./ViewOrganizationGeneralInformation.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationGeneralInformation.vue?vue&type=script&lang=js"

import "./general-info.scss?vue&type=style&index=0&id=e19120c2&lang=scss&scoped=true"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e19120c2"]])

export default __exports__